import "./index.css";
import "@fontsource/rajdhani/400.css";
import "@fontsource/rajdhani/500.css";
import "@fontsource/rajdhani/600.css";
import "@fontsource/rajdhani/700.css";
import "@fontsource/zen-dots/400.css";
import "@fontsource-variable/noto-sans-sc";

import { render } from "solid-js/web";

import { App } from "./app";
import { registerForUpdates } from "./lib/sw-update";

const root = document.getElementById("root");

if (!root) throw new Error("#root element not found");

render(() => <App />, root);

// Reveal after fonts are ready (or after 2s on slow connections) - prevents font FOUC.
const reveal = () => root.classList.add("ready");
Promise.race([document.fonts.ready, new Promise<void>((r) => setTimeout(r, 2000))]).then(reveal);

// Register the service worker and keep it updated. Production only: the dev
// server runs no worker. A new deploy is applied at the next safe moment (tab
// backgrounded or a route change) rather than mid-interaction.
if (import.meta.env.PROD) registerForUpdates();
